export default __webpack_public_path__ + "static/media/acrilicos.85226cf1.jpg";